
<div class="spinner-wrapper" :style="wrapperStyles">
  <div class="spinner" :style="spinnerStyles">
    <div class="spinner-circle" />
  </div>
</div>
